import { push } from 'connected-react-router';
import _ from 'lodash';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';
import FileHelper from '../helpers/file';
import LocalStorageHelper from '../helpers/local_storage';


export function getWebFormConfiguration() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_WEB_FORM_PAGE_REQUEST,
			payload: {
				loading: true,
				hasLoaded: false
			}
		});

		const response = await API.web_form.getWebFormConfig();

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_WEB_FORM_PAGE_ERROR,
				payload: {
					loading: false,
					hasLoaded: false
				}
			});
		}

		const { web_form_config } = response.data;

		dispatch({
			type: ActionTypes.GET_WEB_FORM_PAGE_SUCCESS,
			payload: {
				loading: false,
				hasLoaded: true,
				web_form: web_form_config
			}
		});
	};
}

export function getIncidentTypes() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_WEB_FORM_INCIDENT_TYPES_REQUEST,
			payload: {
				loading: true,
				hasLoaded: false
			}
		});

		const response = await API.web_form.getIncidentTypes();

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_WEB_FORM_INCIDENT_TYPES_ERROR,
				payload: {
					meta: response.meta,
					loading: false,
					hasLoaded: false
				}
			});
		}

		const { incident_types } = response.data;

		const formatIncidentTypes = [];
		incident_types.length > 0 && incident_types.map(incident_type => formatIncidentTypes.push({ value: incident_type._id, label: incident_type.name }));

		dispatch({
			type: ActionTypes.GET_WEB_FORM_INCIDENT_TYPES_SUCCESS,
			payload: {
				loading: false,
				incident_types: formatIncidentTypes,
				hasLoaded: true
			}
		});
	};
}

export function getCategories() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_WEB_FORM_CATEGORIES_REQUEST,
			payload: {
				loading: true,
				hasLoaded: false
			}
		});

		const response = await API.web_form.getCategories();

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_WEB_FORM_CATEGORIES_ERROR,
				payload: {
					meta: response.meta,
					loading: false,
					hasLoaded: false
				}
			});
		}

		const { categories } = response.data;

		dispatch({
			type: ActionTypes.GET_WEB_FORM_CATEGORIES_SUCCESS,
			payload: {
				loading: false,
				categories: categories,
				hasLoaded: true
			}
		});
	};
}

export function onSubmit(fields) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.SUBMIT_WEB_FORM_PAGE_REQUEST,
			payload: {
				loadingSubmit: true,
				hasLoaded: false
			}
		});

		const assets = [];

		if (!_.isNil(fields)) {
			// Add asset
			let fileExtension;
			let base64String;
			let asset;
			if (fields.attachments.length > 0) {
				for (let i = 0; i < fields.attachments.length; i++) {
					const attachment = fields.attachments[i];
					fileExtension = await FileHelper.getExtension(attachment.name);
					base64String = await FileHelper.fileToDataUrl(attachment);
					asset = {
						name: attachment.name,
						file_type: attachment.type || fileExtension,
						file_name: attachment.name,
						file_extension: fileExtension,
						file_content: base64String
					};
					assets.push(asset);
				}
			}
		}

		if (!LocalStorageHelper.getEmail()) {
			alert('No email found');
			return;
		}

		const body = {
			web_form: {
				incident_date: fields.incident_date,
				incident_type_id: fields.incident_type,
				category_id: fields.categories[0],
				sub_category_id: fields.sub_categories[0],
				details: fields.details,
				share_data: fields.share_info,
				...(assets && { attachments: assets })
			}
		};

		const response = await API.web_form.createWebForm(body);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_WEB_FORM_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false,
					hasLoaded: false
				}
			});
			return;
		}

		dispatch(push('/success'));

		// const { ticket: newTicket } = response.data;

		// dispatch({
		//     type: ActionTypes.SUBMIT_WEB_FORM_PAGE_SUCCESS,
		//     payload: {
		//         meta: response.meta,
		//         loadingSubmit: false,
		//         hasLoaded: true
		//     }
		// });
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_WEB_FORM_PAGE_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_WEB_FORM_PAGE
		});
	};
}
